import"./chunk-PXDN3KFO.js";var a=o=>{let t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",e=o||10,r="";for(let n=0;n<e;n++)r+=t.charAt(Math.floor(Math.random()*t.length));return r};export{a as getRandomStringId};
